import React from 'react';
import { Button, Card, Form, Input, Modal } from 'antd';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postRequest, ResponseDataType } from 'api';
import { DatePicker } from 'Components';
import styles from './info.module.css';

interface CreateParentDataType {
    name: string;
    dob: any;
    email?: string;
    phoneNumber: string;
}

export const CreateParent = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const handleCreate = async (value: CreateParentDataType) => {
        const dobString = value.dob?.format ? value.dob.format("YYYY-MM-DD") : value.dob;

        Modal.confirm({
            style: { fontFamily: 'Quicksand' },
            title: 'Xác nhận thêm phụ huynh?',
            async onOk() {
                const response: ResponseDataType<any> = await postRequest(
                    '/cms/parent',
                    { ...value, dob: dobString },
                    'json'
                );

                if (response && response.code === 200) {
                    toast.success('Thêm phụ huynh thành công!');
                    navigate('/parent-list');
                } else {
                    toast.error('Thêm phụ huynh thất bại!');
                }
            },
        });
    };

    return (
        <Card title="Thêm phụ huynh" className={styles.customer_info_card}>
            <Form form={form} onFinish={handleCreate} layout="vertical">
                <Form.Item
                    label="Tên phụ huynh"
                    name="name"
                    rules={[{ required: true, message: 'Vui lòng nhập tên' }]}
                >
                    <Input placeholder="Nhập tên phụ huynh" />
                </Form.Item>

                <Form.Item
                    label="Ngày sinh"
                    name="dob"
                    rules={[{ required: true, message: 'Vui lòng chọn ngày sinh' }]}
                >
                    <DatePicker
                        style={{ width: '100%' }}
                        placeholder="Chọn hoặc dán ngày sinh"
                    />
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { type: 'email', message: 'Email không hợp lệ' },
                    ]}
                >
                    <Input placeholder="Nhập email" />
                </Form.Item>

                <Form.Item
                    label="Số điện thoại"
                    name="phoneNumber"
                    rules={[{ required: true, message: 'Vui lòng nhập số điện thoại' }]}
                >
                    <Input placeholder="Nhập số điện thoại" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Thêm phụ huynh
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};
